import GeneralDeclarationRequest    from '../../api/requests/generalDeclarationRequest';
import contactUsRequest             from '../../api/requests/contactUsRequest';
import AutocompleteRequest          from '../../api/requests/AutocompleteRequest';
import GetHomepageRequest           from '../../api/requests/getHomepageRequest';
import getContactUsPageRequest      from '../../api/requests/getContactUsPageRequest';
import ContentPageRequest           from '../../api/requests/getContentPageRequest';
import OurStoryRequest              from '../../api/requests/getOurStoryRequest';
import BenefitByIdRequest           from '../../api/requests/benefitByIdRequest';
import SendAppLinkSmsRequest        from '../../api/requests/sendAppLinkSmsRequest';
import SearchBenefitsRequest        from '../../api/requests/SearchBenefitsRequest';
import SignupForNewsletterRequest   from '../../api/requests/signupForNewsletterRequest';
import getMetaTagsRequest           from '../../api/requests/getMetaTagsRequest';
import getSuppliersApplicationPage  from '../../api/requests/getSuppliersApplicationPage';
import getUsersApplicationPage      from '../../api/requests/getUsersApplicationPage';
import newUserApplication           from '../../api/requests/NewUserApplication';
import newSupplierApplication       from '../../api/requests/NewSupplierApplication';
import MembershipValidationRequest  from '../../api/requests/MembershipValidationRequest';
import getSmartWalletPageRequest    from '../../api/requests/getSmartWalletPageRequest';
import GetMembershipGeneratorPage   from '../../api/requests/getMembershipGeneratorPage';
import GetClubMemberCertificate     from '../../api/requests/getClubMemberCertificate';
import HotWebUserLogin              from '../../api/requests/HotWebUserLogin';
import HotWebUserFirstLogin         from '../../api/requests/HotWebFirstLogin';
import GenerateVerificationCode     from '../../api/requests/generateWebVerificationCode';
import CheckVerificationCode        from '../../api/requests/checkVerificationCode';
import getUserFavoritesRequest      from '../../api/requests/getUserFavoritesRequest';
import addFavoriteRequest           from '../../api/requests/addFavoriteRequest';
import removeFavoriteRequest        from '../../api/requests/removeFavoriteRequest';
import HotAddUser                   from '../../api/requests/hotAddUser';
import GetUserData                  from '../../api/requests/getUserData';
import Logout                       from '../../api/requests/Logout';
import EditUserInformation          from '../../api/requests/editUserInformation';
import AcquireCouponWebRequest      from '../../api/requests/acquireCouponWeb';
import CleanUserSearchHistory       from '../../api/requests/cleanUserSearchHistory';
import SendBenefitCoupon            from '../../api/requests/sendBenefitCoupon';
import AddTokenRequest              from '../../api/requests/addTokenRequest';
import DeleteTokenRequest           from '../../api/requests/deleteTokenRequest';
import SetDefaultTokenRequest       from '../../api/requests/setDefaultTokenRequest';
import GetAvailableCoupons          from '../../api/requests/getAvailableCoupons';
import AskTheExpert                 from '../../api/requests/askTheExpert';
import GetExpertsPage               from '../../api/requests/getExpertsPage';
import AcquirePaidCouponRequest     from '../../api/requests/AcquirePaidCouponRequest';
import GetStreetsByCityId           from '../../api/requests/getStreetsByCityId';
import SaveUserAddress              from '../../api/requests/saveUserAddress';
import DeleteUserAddress            from '../../api/requests/deleteUserAddress';
import GetDetailedBenefitCouponHash from '../../api/requests/getDetailedBenefitCouponHash';
import UpdateUserAddress            from '../../api/requests/updateUserAddress';
import SetDefaultAddress            from '../../api/requests/setDefaultAddress';
import AddItemRequest               from '../../api/requests/addItemRequest';
import EditItemRequest              from '../../api/requests/editItemRequest';
import GetCartRequest               from '../../api/requests/getCartRequest';
import VerifyCartRequest            from '../../api/requests/verifyCartRequest';
import DoPaymentRequest             from '../../api/requests/doPaymentRequest';
import GetUserOrdersRequest         from '../../api/requests/getUserOrders';
import GetUserOrderRequest          from '../../api/requests/GetUserOrderRequest';
import GetItems                     from '../../api/requests/getItems';
import GetCustomerSurvey            from '../../api/requests/getCustomerSurvey';
import AnswerCustomerSurvey         from '../../api/requests/answerCustomerSurvey';
import OrderNotReceivedReply         from '../../api/requests/orderNotReceivedReply';
import NewIncompleteUserApplicationRequest         from '../../api/requests/newIncompleteUserApplicationRequest';
import GetApplicationLandingPageRequest         from '../../api/requests/getApplicationLandingPageRequest';
import GetUsersApplicationApprovalPage         from '../../api/requests/getUsersApplicationApprovalPage';
import ReactCrashLog         from '../../api/requests/reactCrashLog';
import SmartWalletApplication from "../../api/requests/smartWalletApplication";
import GetVehicleAdsPage from "../../api/requests/getVehicleAdsPage";
import SetNewVehicleLead from "../../api/requests/setNewVehicleLead";
import NewVehicleLead from "../../api/requests/setNewVehicleLead";
import SendLeadForm from '../../api/requests/sendLeadForm';
import GetMagazineMainPageInfo from 'api/requests/getMagazineMainPageInfo';
import GetArticlesByCategory from 'api/requests/getArticlesByCategory';
import GetArticleById from 'api/requests/getArticleById';
import GetVideoArticleById from 'api/requests/getVideoArticleById';
import GetVideoArticles from 'api/requests/getVideoArticles';
import GetArticlesByAmount from 'api/requests/getHomepageMagazineArticles';
import GetLegalAdvicePageRequest from '../../api/requests/GetLegalAdvicePageRequest';
import GetLegalAdviceQuestionRequest from '../../api/requests/GetLegalAdviceQuestionRequest';
import GetLegalAdviceQuestionsRequest from '../../api/requests/GetLegalAdviceQuestionsRequest';
import SearchLegalAdviceQuestionsRequest from '../../api/requests/SearchLegalAdviceQuestionsRequest';
import SubmitLegalAdviceQuestionRequest from '../../api/requests/SubmitLegalAdviceQuestionRequest';
import GetAllBenefits from '../../api/requests/GetAllBenefits';
import GetCategoryBenefits from '../../api/requests/GetCategoryBenefits';
import UpdateVideoArticlesViewCount from '../../api/requests/UpdateVideoArticlesViewCount';
import CheckForPreviousUserApplication from '../../api/requests/CheckForPreviousUserApplication';
import RequestAccessToken from '../../api/requests/RequestAccessToken';
import CreateInsuranceLead from '../../api/requests/CreateInsuranceLead';
import SetTravelInsurancePopupAgreement from '../../api/requests/SetTravelInsurancePopupAgreement';
import SetLegalWaiverAgreement from '../../api/requests/SetLegalWaiverAgreement';
import UpdateUserDataSharingConsent from '../../api/requests/UpdateUserDataSharingConsent';
import SubmitBenefitLeadForm from '../../api/requests/SubmitBenefitLeadForm';
import initLoginRequest from '../../api/requests/initLoginRequest';
import loginRequest from '../../api/requests/loginRequest';
import ForumFindOnePost from '../../api/requests/ForumFindOnePost';
import ForumFindAllPosts from '../../api/requests/ForumFindAllPosts';
import ForumCreatePost from '../../api/requests/ForumCreatePost';
import ForumFindAllComments from '../../api/requests/ForumFindAllComments';
import ForumCreateComment from '../../api/requests/ForumCreateComment';
import GetFilteredBenefits from "../../api/requests/GetFilteredBenefits";
import UpdateDataSharingAndMarketingConsents from "../../api/requests/updateDataSharingAndMarketingConsents";
import GetIsMarketingApproved from "../../api/requests/getIsUserApprovedMarketing";
import ValidateHotUser from "../../api/requests/ValidateHotUser";


const purchaseLock = {
    isLocked: false,
    lock: () => {
        purchaseLock.isLocked = true;
    },
    unlock: () => {
        purchaseLock.isLocked = false;
    },
};

/* Async actions - implemented via thunk middleware */
export function getGeneralDeclaration() {
    let Request = new GeneralDeclarationRequest();
    return dispatch => {
        Request.execute(dispatch);
    }
}

export function orderNotReceivedReply(payload) {
    let request = new OrderNotReceivedReply();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getUsersApplicationApprovalPage(payload) {
    let request = new GetUsersApplicationApprovalPage();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getApplicationLandingPage(payload) {
    let request = new GetApplicationLandingPageRequest();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function newIncompleteUserApplication(payload) {
    let request = new NewIncompleteUserApplicationRequest();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function reactCrashLog(payload) {
    let request = new ReactCrashLog();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function answerCustomerSurvey(payload) {
    return dispatch =>{
        new AnswerCustomerSurvey().execute(dispatch, payload);
    }
}

export function getCustomerSurvey(payload) {
    let request = new GetCustomerSurvey();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getItems(payload) {
    let request = new GetItems();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function addItem(payload) {
    let request = new AddItemRequest();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function editItem(payload) {
    let request = new EditItemRequest();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getCart() {
    let request = new GetCartRequest();
    return dispatch =>{
        request.execute(dispatch);
    }
}

export function verifyCartRequest(payload) {
    let request = new VerifyCartRequest();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function doPayment(payload, onPurchase = () => {}) {
    let request = new DoPaymentRequest(onPurchase);
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function setDefaultAddress(payload) {
    let request = new SetDefaultAddress();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function updateUserAddress(payload) {
    let request = new UpdateUserAddress();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function smartWalletApplication(payload) {
    let request = new SmartWalletApplication();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function deleteUserAddress(payload) {
    let request = new DeleteUserAddress();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}
export function getDetailedBenefitCouponHash(payload) {
    let request = new GetDetailedBenefitCouponHash();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function saveUserAddress(payload) {
    let request = new SaveUserAddress();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getStreetByCityId(payload){
    let request = new GetStreetsByCityId();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getAvailabaleCoupons(payload, listener) {
    let request = new GetAvailableCoupons(listener);
    purchaseLock.unlock();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}


export function acquirePaidCoupon(payload, onPurchaseResponse = () => {}, onAnyResponse = () => {}, benefit = null, translations = {}, onClose = null) {
    if (purchaseLock.isLocked) { return }
    purchaseLock.lock();
    let request = new AcquirePaidCouponRequest(onPurchaseResponse, onAnyResponse, benefit, translations, onClose);
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getUserFavorites() {
    let Request = new getUserFavoritesRequest();
    return dispatch => {
        Request.execute(dispatch);
    }
}
export function addFavorite(payload) {
    let Request = new addFavoriteRequest();
    return dispatch => {
        Request.execute(dispatch, payload);
    }
}
export function removeFavorite(payload) {
    let Request = new removeFavoriteRequest();
    return dispatch => {
        Request.execute(dispatch, payload);
    }
}
export function getSuppliersApplication() {
    let Request = new getSuppliersApplicationPage();
    return dispatch => {
        Request.execute(dispatch);
    }
}
export function getMetaTags(payload) {
    let Request = new getMetaTagsRequest();
    return dispatch => {
        Request.execute(dispatch, payload);
    }
}
export function searchBenefits(payload, onResponse = () => {}) {
    let request = new SearchBenefitsRequest(onResponse);
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}
export function sendContactUs(payload) {
    let request = new contactUsRequest();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}
export function getHomepage() {
    let request = new GetHomepageRequest();
    return dispatch =>{
        request.execute(dispatch);
    }
}
export function getAutocompleteResults(query, onResponse = () => {}, signal) {
    let request = new AutocompleteRequest(onResponse, signal);
    return dispatch => {
        request.execute(dispatch, query);
    };
}
export function getContactUsPage() {
    let request = new getContactUsPageRequest();
    return dispatch =>{
        request.execute(dispatch);
    }
}
export function getContentPage(payload) {
    let request = new ContentPageRequest();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}
export function getOurStoryPage() {
    let request = new OurStoryRequest();
    return dispatch =>{
        request.execute(dispatch);
    }
}
export function getBenefitById(payload) {
    let request = new BenefitByIdRequest();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}
export function sendAppLinkSms(payload, sender = '') {
    let request = new SendAppLinkSmsRequest();
    return dispatch =>{
        request.execute(dispatch, payload, sender);
    }
}

export function signupForNewsletter(payload, afterSuccess = () => {}) {
    let request = new SignupForNewsletterRequest(afterSuccess);
    return dispatch => {
        request.execute(dispatch, payload);
    }
}

export function getClientsApplicationPage() {
    let request = new getUsersApplicationPage();
    return dispatch =>{
        request.execute(dispatch);
    }
}

export function setUserApplication(payload, onResponse = () => {}) {
    let request = new newUserApplication(onResponse);
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function setSupplierApplication(payload) {
    let request = new newSupplierApplication();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function setMembershipValidation(payload, route) {
    let request = new MembershipValidationRequest();
    return dispatch =>{
        request.execute(dispatch, payload, route);
    }
}

export function getSmartWalletPage() {
    let request = new getSmartWalletPageRequest();
    return dispatch =>{
        request.execute(dispatch);
    }
}

export function getMembershipGeneratorPage() {
    let request = new GetMembershipGeneratorPage();
    return dispatch =>{
        request.execute(dispatch);
    }
}

export function getClubMemberCertificate(payload) {
    let request = new GetClubMemberCertificate();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function sendLoginRequest(payload) {
    let request = new HotWebUserLogin();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function sendFirstLoginRequest(payload) {
    let request = new HotWebUserFirstLogin();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function newUserLoginRequest(payload) {
    let request = new initLoginRequest();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}

export function validateHotUser(payload){
    let request = new ValidateHotUser();
    return dispatch => {
        request.execute(dispatch, payload);
    }
}

export function generateVereficationCode(payload) {
    let request = new GenerateVerificationCode();
    return dispatch => request.execute(dispatch, payload);
    
}

export function newDoLoginRequest(payload) {
    let request = new loginRequest();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}
export function checkVerificationCode(payload) {
    let request = new CheckVerificationCode();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function hotAddUser(payload) {
    let request = new HotAddUser();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getUserData(isShowPopups=true) {
    let request = new GetUserData(isShowPopups);
    return dispatch =>{
        request.execute(dispatch);
    }
}

export function logout() {
    let request = new Logout();
    return dispatch =>{
        request.execute(dispatch);
    }
}


export function editUserInformation(payload) {
    let request = new EditUserInformation();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function acquireCoupon(payload, benefit = null, translations = {}, onClose = null) {
    let request = new AcquireCouponWebRequest(benefit, translations, onClose);
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function acquireCouponWeb(payload, benefit = null, translations = {}, onClose = null) {
    let request = new AcquireCouponWebRequest(benefit, translations, onClose);
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function cleanUserSearchHistory() {
    let request = new CleanUserSearchHistory();
    return dispatch =>{
        request.execute(dispatch);
    }
}

export function sendBenefitCoupon(payload) {
    let request = new SendBenefitCoupon();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function addToken(payload) {
    //runs on add card click
    let request = new AddTokenRequest();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function deleteToken(payload) {
    let request = new DeleteTokenRequest();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function setDefaultToken(payload) {
    let request = new SetDefaultTokenRequest();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}


export function getIsMarketingApproved(payload, listener) {
    let request = new GetIsMarketingApproved(listener);
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}

export function askTheExpert(payload) {
    let request = new AskTheExpert();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getExpertsPage() {
    let request = new GetExpertsPage();
    return dispatch =>{
        request.execute(dispatch);
    }
}

export function getUserOrders() {
    let request = new GetUserOrdersRequest();
    return dispatch =>{
        request.execute(dispatch);
    }
}
export function getUserOrder(payload) {
    let request = new GetUserOrderRequest();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getVehicleAdsPage(payload) {
    let request = new GetVehicleAdsPage();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function setLegalWaiverAgreement(payload, onSuccess) {
    let request = new SetLegalWaiverAgreement(onSuccess);
    return dispatch => {
        request.execute(dispatch, payload);
    }
}

export function newVehicleLead(payload) {
    let request = new NewVehicleLead();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function sendLeadForm(payload) {
    let request = new SendLeadForm();
    return dispatch => {
        request.execute(dispatch, payload);
    }
}

export function getMagazineMainPageInfo(onSuccess, payload) {
    let request = new GetMagazineMainPageInfo(onSuccess);
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getHomepageMagazineArticles() {
    let request = new GetArticlesByAmount();
    return dispatch =>{
        request.execute(dispatch, { amount: 6 });
    }
}

export function getArticlesByCategory(onSuccess, payload) {
    let request = new GetArticlesByCategory(onSuccess);
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}
export function getArticleById(onSuccess, payload) {
    let request = new GetArticleById(onSuccess);
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}
export function getVideoArticleById(onSuccess, payload) {
    let request = new GetVideoArticleById(onSuccess);
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}
export function getVideoArticles(onSuccess, payload) {
    let request = new GetVideoArticles(onSuccess);
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getLegalAdvicePage() {
    let request = new GetLegalAdvicePageRequest();
    return dispatch => {
        request.execute(dispatch);
    };
}

export function getLegalAdviceQuestion(payload) {
    let request = new GetLegalAdviceQuestionRequest();
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function getLegalAdviceQuestions() {
    let request = new GetLegalAdviceQuestionsRequest();
    return dispatch => {
        request.execute(dispatch);
    };
}

export function searchLegalAdviceQuestions(payload) {
    let request = new SearchLegalAdviceQuestionsRequest();
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function submitLegalAdviceQuestion(payload) {
    let request = new SubmitLegalAdviceQuestionRequest();
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function getAllBenefits(payload) {
    let request = new GetAllBenefits();
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function getFilteredBenefits(payload) {
    let request = new GetFilteredBenefits();
    return dispatch => {
        request.execute(dispatch, payload);
    };
}
export function getCategoryBenefits(payload) {
    let request = new GetCategoryBenefits();
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function updateVideoArticlesViewCount(payload) {
    let request = new UpdateVideoArticlesViewCount();
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function checkForPreviousUserApplication(onSuccess, payload) {
    let request = new CheckForPreviousUserApplication(onSuccess);
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function requestAccessToken(onSuccess, onFailure) {
    let request = new RequestAccessToken(onSuccess, onFailure);
    return dispatch => {
        request.execute(dispatch);
    };
}

export function createInsuranceLead(payload, onSuccess, onFailure) {
    let request = new CreateInsuranceLead(onSuccess, onFailure);
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function setTravelInsurancePopupAgreement(onSuccess) {
    let request = new SetTravelInsurancePopupAgreement(onSuccess);
    return dispatch => {
        request.execute(dispatch);
    };
}

export function updateUserDataSharingConsent(payload, onSuccess, onFail) {
    let request = new UpdateUserDataSharingConsent(onSuccess, onFail);
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function updateUserDataSharingAndMarketingConsent(payload, onSuccess, onFail) {
    let request = new UpdateDataSharingAndMarketingConsents(onSuccess, onFail);
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function submitBenefitLeadForm(payload, onSuccess) {
    let request = new SubmitBenefitLeadForm(onSuccess);
    return dispatch => {
        request.execute(dispatch, payload);
    };
}

export function forumFindOnePost(postId, forumConfiguration, handleSuccess, handleFailure) {
    const request = new ForumFindOnePost(postId, forumConfiguration, handleSuccess, handleFailure);

    return (dispatch) => {
        request.execute(dispatch);
    };
}

export function forumFindAllPosts(payload, forumConfiguration, handleSuccess, handleFailure) {
    const request = new ForumFindAllPosts(forumConfiguration, handleSuccess, handleFailure);

    return (dispatch) => {
        request.execute(dispatch, payload);
    };
}

export function forumCreatePost(payload, forumConfiguration, handleSuccess, handleFailure) {
    const request = new ForumCreatePost(forumConfiguration, handleSuccess, handleFailure);

    return (dispatch) => {
        request.execute(dispatch, payload);
    };
}

export function forumFindAllComments(
    postId,
    payload,
    forumConfiguration,
    handleSuccess,
    handleFailure,
) {
    const request = new ForumFindAllComments(
        postId,
        forumConfiguration,
        handleSuccess,
        handleFailure,
    );

    return (dispatch) => {
        request.execute(dispatch, payload);
    };
}

export function forumCreateComment(
    postId,
    payload,
    forumConfiguration,
    handleSuccess,
    handleFailure,
) {
    const request = new ForumCreateComment(
        postId,
        forumConfiguration,
        handleSuccess,
        handleFailure,
    );

    return (dispatch) => {
        request.execute(dispatch, payload);
    };
}

export function filterSearch(filters, fields) {


    return (dispatch) => {

    }

}
